/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-07-27 17:25:44
 * @LastEditTime: 2022-03-21 15:38:36
 * @FilePath: /teacher-h5/src/service/students/index-url.js
 */
let baseUrl = ''
// const passportUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = ''
} else {
  baseUrl = 'https://jzx.aixuexi.com'
  // passportUrl = 'https://www.aixuexi.com'
}

export default {
  // 学生列表
  studentList: `${baseUrl}/teaching/api/student/studentList`,
  // 删除学生
  delStudent: `${baseUrl}/teaching/api/student/del`,
  // 添加学员
  addStudent: `${baseUrl}/teaching/api/student/add`,
  // 修改学员
  updateStudent: `${baseUrl}/teaching/api/student/update`,
  // 体验卡激活
  activate: `${baseUrl}/teaching/api/card/activate`,
  // 卡详情（续卡/添加新卡）
  cardDetail: `${baseUrl}/teaching/api/card/detail`,
  // 学员续期明细
  paymentRecords: `${baseUrl}/teaching/api/card/paymentRecords`,
  // 新卡添加
  addCard: `${baseUrl}/teaching/api/card/add`,
  // 机构学员列表
  insStudents: `${baseUrl}/teaching/api/student/insStudents`,
  // 年级列表
  gradeList: `${baseUrl}/teaching/api/grade/list`,
  // 教材版本列表
  bookVersionList: `${baseUrl}/teaching/api/bookVersion/list`,
  // 年纪列表
  rankList: `${baseUrl}/teaching/api/rank/list`,
  // 学员档案
  studentDetail: `${baseUrl}/teaching/api/student/detail`,
  // 根据手机号获取学生
  getByPhone: `${baseUrl}/teaching/api/student/getByPhone`,
  // 验证学员-开发过程中使用
  addTest: `${baseUrl}/teaching/api/student/addTest`,
  // 测试接口：验证通过
  getTestCard: `${baseUrl}/teaching/api/student/getTestCard`,
  // 再次发送验证消息
  sendValidMsg: `${baseUrl}/teaching/api/student/sendValidMsg`,
  // 获取验证码
  sendValidMsg2: `${baseUrl}/teaching/api/student/sendValidMsg2`,
  // 批量添加卡页面详情年级和科目
  subjectAndGrade: `${baseUrl}/teaching/api/card/subjectAndGrade`,
  // 机构精准学学员列表
  getJzxStudents: `${baseUrl}/teaching/api/student/jzxStudents`,
  // 正式卡-批量添加
  batchAdd: `${baseUrl}/teaching/api/card/batchAdd`,
  // 重置密码
  resetPwd: `${baseUrl}/teaching/api/student/resetPwd`,

  // 学员与小组
  // 获取学员小组列表
  getGroupList: `${baseUrl}/teaching/api/group/list`,
  // 获取学员小组列表-分页
  getGroupPageList: `${baseUrl}/teaching/api/group/page/list`,
  // 小组添加学员
  addGroupStudent: `${baseUrl}/teaching/api/group/addStudent`,
  // 解散小组
  delGroup: `${baseUrl}/teaching/api/group/dissolve`,
  // 创建小组
  createGroup: `${baseUrl}/teaching/api/group/create`,
  // 小组学员
  getGroupStudent: `${baseUrl}/teaching/api/studentList/list`,
  // 更新小组排序
  sortGroup: `${baseUrl}/teaching/api/group/group/sort`,
  // 更新小组信息
  updateGroup: `${baseUrl}/teaching/api/group/update`,
  // 批量删除学员
  batchDelStudent: `${baseUrl}/teaching/api/student/batchDel`,
  // 验证方式2
  validMsg: `${baseUrl}/teaching/api/student/validMsg`,
  // 获取机构所有老师
  getTeacherList: `${baseUrl}/teaching/api/teacher/list`,
  // 获取自己的组
  groupUserList: `${baseUrl}/teaching/api/studentList/groupUserList`,
  // 批量添加机构学员
  batchAddStudent: `${baseUrl}/teaching/api/student/batchAdd`,
  // 移出组员
  removeGroupStudent: `${baseUrl}/teaching/api/group/remove/student`,

  // 批量添加学员
  // 校验表格数据是否正确
  queryErrorList: `${baseUrl}/teaching/api/studentExcel/queryErrorList`,
  // 提交表格数据
  submitExcel: `${baseUrl}/teaching/api/studentExcel/submit`,
  // 删除学员
  deleteStudent: `${baseUrl}/teaching/api/studentExcel/delete`,
  // 更新学员
  updateExcel: `${baseUrl}/teaching/api/studentExcel/update`,
  // 上传excel
  batchSaveStudentInfo: `${baseUrl}/teaching/api/studentExcel/batchSaveStudentInfo`
}
